import { HttpMethod } from "../common/lib/fetch/useFetch";
import { RequestOptions } from "../common/lib/fetch/useRequest";
import useUserRequest from "../common/lib/fetch/useUserRequest";
import { useUser } from "../userAccess/useUser";

const useRemoveStagedPurchaseOrder = (stagedPurchaseOrderId: string, options?: RequestOptions) => {
  const user = useUser();

  return useUserRequest<void>({
    method: HttpMethod.POST,
    path: `/api/sites/${user.selectedSite?.id}/stagedPurchaseOrders/${stagedPurchaseOrderId}/remove`
  }, options);
}

export default useRemoveStagedPurchaseOrder;